import React from 'react'
import styled, { css } from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { MenuData } from '../data/MenuData';
import { Button } from './Button';
import { ImStatsBars } from 'react-icons/im';
import  Image  from '../images/logo.jpg';







const Nav = styled.nav`
    height: 60px;
    display: flex;
    justify-content: space-between;
    padding: 1rem 2rem ;
    z-index: 100;
    position: fixed;
    width: 100%;
    
   
`;

const NavLink = css`
    color: #fff;
    display: flex;
    align-items: center;
    padding: 0rem 1rem;
    height: 100%;
    cursor: pointer;
    text-decoration: none;
`;


const Logo = styled(Link)`
    

`;




const MenuBars = styled(ImStatsBars)`
    display: none;

    
    @media screen and (max-width: 768px) {
        display: block;
    }
`;

const NavMenu = styled.div`
    display: flex;
    align-items: center;
    margin-right: -45px;

    @media screen and (max-width: 768px) {
        display: none;
    }
`;

const NavMenuLink = styled(Link)`
    ${NavLink}
`;
const NavBtn = styled.div`
    display: flex;
    align-items: center;
    margin-right: 20px;

    @media screen and (max-width: 768px) {
        display: none;
    }
`;


const Navbar = ({toggle, img}) => {
    return (
        <Nav>
            <Logo to='/'  ><img src={Image} alt='/' /></Logo>
            <MenuBars onClick={toggle}/>
            <NavMenu>
                {MenuData.map((item, index) => (
                    <NavMenuLink to={item.link} key={index}>
                        {item.title}
                    </NavMenuLink>
                ))}
            </NavMenu>
            <NavBtn>
                <Button to='/contect' primary='true'>Content Us</Button>
            </NavBtn>
        </Nav>
    );
}

export default Navbar;
